import React from "react";

export const ProjectInfoSkeleton = () => (
  <div className="px-2_5 py-2 d-flex flex-nowrap justify-content-between border-bottom">
    <div className="col-6">
      <div className="shortloadingLine col-8 rounded"></div>
      <div className="shortloadingLine col-12 rounded"></div>
    </div>
    <div className="col-4">
      <div className="shortloadingLine col-8 rounded"></div>
      <div className="shortloadingLine col-12 rounded"></div>
    </div>
  </div>
);
